import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi =
  ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getQuestionnaireAgents = async ({
  questionnaireTemplateId,
  creatorId,
  page,
  perPage,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(
    '/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents',
    { creatorId, questionnaireTemplateId },
  );
  const data = await formsBackendClient.get(path, { params: { page, perPage } });
  return data.data;
};

export default getQuestionnaireAgents;
